import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { LogisticService, UnitItem } from '@app/services/logistic.service';

@Component({
    selector: 'tt-db-station',
    templateUrl: './db-station.component.html',
    styleUrls: ['./db-station.component.css'],
})
export class DbStationComponent implements OnInit {
    public edit?: Edit;

    public testingAccessToken = false;

    public saving = false;

    public units: UnitItem[] = [];

    constructor(
        private stateService: StateService,
        private modal: ModalService,
        private datatask: DataTaskService,
        private logistic: LogisticService,
    ) {}

    private async loadEdit() {
        this.edit = (await this.datatask.Post(2298))[0];
    }

    public async testChanges() {
        if (!!this.edit) {
            try {
                this.testingAccessToken = true;

                const response = (await this.datatask.Post(2301, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage,
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.testingAccessToken = false;
            }
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2300, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage,
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async loadUnits() {
        this.units = await this.logistic.getUnitList();
    }

    private async init() {
        this.loadUnits();
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    company_id: string;
    user_name: string;
    user_pass: string;
    proxy_url: string;
    printserver_proxy_id: string;
    printserver_grant_type: string;
    printserver_scope_value: string;
    printserver_client_id: string;
    printserver_client_secret: string;
    fileserver_proxy_id: string;
    fileserver_grant_type: string;
    fileserver_scope_value: string;
    fileserver_client_id: string;
    fileserver_client_secret: string;
    warning_message: string;
    email_tag_prefix: string;
    unit_no_kg: string | number;
    unit_no_meter: string | number;
    unit_no_m2: string | number;
    unit_no_pcs: string | number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('dbStation', {
//        templateUrl: 'views/components/views/dbStation/dbStation.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'translateService', 'modalService', 'dbStationService', function (stateService, translateService, modalService, dbStationService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                testingAccessToken: false,
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await dbStationService.getDbStation())[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON TEST ACCESS TOKEN FUNCTION

//            vm.testChanges = function () {
//                vm.model.testingAccessToken = true;

//                dbStationService.testAccessToken(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.testingAccessToken = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.testingAccessToken = false;
//                    }
//                });
//            };

//            // #endregion BUTTON TEST ACCESS TOKEN FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                dbStationService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
